import { Logger } from '@/utils/Logger';

const loadScript = (url: string) => {
  return new Promise<void>((resolve, reject) => {
    const script = document.createElement('script');
    script.src = url;
    script.async = true;

    script.onload = () => {
      resolve();
    };

    script.onerror = error => {
      Logger.error('AdobeDTM', `Failed to load script: ${url}`, error);
      reject(error);
    };

    document.head.appendChild(script);
  });
};

export const loadAdobeDTMScript = async () => {
  const scriptUrls: Record<'production' | 'development', string> = {
    production: 'https://assets.adobedtm.com/9215900255c9/17f1b4dd3439/launch-bb453ba32d52.min.js',
    development: 'https://assets.adobedtm.com/9215900255c9/17f1b4dd3439/launch-3cdcd1196ea2-staging.min.js',
  };

  const mode = import.meta.env.MODE as 'production' | 'development';
  const urlToLoad = scriptUrls[mode];

  if (!urlToLoad) {
    Logger.warn('AdobeDTM', `Adobe DTM script not configured for mode: ${mode}`);
    return;
  }

  try {
    await loadScript(urlToLoad);
    if (mode === 'production' && window._satellite) {
      window._satellite.track('analyticsconsent_true');
    }
  } catch (error) {
    Logger.error('AdobeDTM', `Error initiating Adobe DTM script for mode: ${mode}`, error);
  }
};
